// src/components/home/SearchBar.js
// Barre de recherche avec autocomplete quartiers - NE PAS MODIFIER

import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { searchQuartier } from '../../data/quartiers';
import ROUTES from '../../constants/routes';

const SearchBar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (query.length >= 2) {
      const results = searchQuartier(query);
      setSuggestions(results.slice(0, 6));
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [query]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelectQuartier = (quartier) => {
    setQuery(quartier.name);
    setShowSuggestions(false);
    navigate(`${ROUTES.SEARCH}?quartier=${encodeURIComponent(quartier.name)}&city=${encodeURIComponent(quartier.city)}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`${ROUTES.SEARCH}?q=${encodeURIComponent(query)}`);
      setShowSuggestions(false);
    }
  };

  const styles = {
    wrapper: {
      position: 'relative',
      padding: '0 16px',
      marginBottom: '8px',
    },
    form: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#111827',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      padding: '4px',
    },
    icon: {
      fontSize: '18px',
      padding: '0 10px',
      color: '#A0AEC0',
    },
    input: {
      flex: 1,
      border: 'none',
      backgroundColor: 'transparent',
      color: '#FFFFFF',
      fontSize: '15px',
      padding: '12px 4px',
      outline: 'none',
    },
    suggestionsContainer: {
      position: 'absolute',
      top: '100%',
      left: '16px',
      right: '16px',
      backgroundColor: '#162033',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      marginTop: '4px',
      overflow: 'hidden',
      zIndex: 1000,
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3)',
    },
    suggestionItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '12px 16px',
      cursor: 'pointer',
      transition: 'background-color 150ms',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    suggestionIcon: {
      fontSize: '14px',
      color: '#FFD700',
    },
    suggestionText: {
      display: 'flex',
      flexDirection: 'column',
    },
    suggestionName: {
      fontSize: '14px',
      color: '#FFFFFF',
      fontWeight: '500',
    },
    suggestionCity: {
      fontSize: '12px',
      color: '#A0AEC0',
    },
  };

  return (
    <div style={styles.wrapper} ref={wrapperRef}>
      <form style={styles.form} onSubmit={handleSubmit}>
        <span style={styles.icon}>🔍</span>
        <input
          type="text"
          style={styles.input}
          placeholder={t('home.searchPlaceholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => query.length >= 2 && setShowSuggestions(true)}
        />
      </form>

      {showSuggestions && suggestions.length > 0 && (
        <div style={styles.suggestionsContainer}>
          {suggestions.map((quartier) => (
            <div
              key={quartier.id}
              style={styles.suggestionItem}
              onClick={() => handleSelectQuartier(quartier)}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <span style={styles.suggestionIcon}>📍</span>
              <div style={styles.suggestionText}>
                <span style={styles.suggestionName}>{quartier.name}</span>
                <span style={styles.suggestionCity}>{quartier.city}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;